import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, NgZone, OnDestroy, OnInit} from '@angular/core';
import {RENTREE_END} from '@services/user.service';

@Component({
    selector: 'app-promo-countdown',
    templateUrl: './promo-countdown.component.html',
    styleUrls: ['./promo-countdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PromoCountdownComponent implements OnInit, OnDestroy {

    // Fin de l'offre, dans le fuseau du visiteur (par défaut celle de la promo de rentrée)
    @Input() end: Date = RENTREE_END;

    days = 0;
    hours = 0;
    minutes = 0;
    seconds = 0;

    private timer = null;

    constructor(private zone: NgZone, private cdr: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.refresh();
        // Hors zone Angular : un tick par seconde ne doit pas relancer la détection de
        // changement de toute la page (tableau des forfaits), seulement ce composant
        this.zone.runOutsideAngular(() => {
            this.timer = setInterval(() => {
                this.refresh();
                this.cdr.detectChanges();
            }, 1000);
        });
    }

    ngOnDestroy(): void {
        if (this.timer != null) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    // Recalculé depuis la date de fin (et non décrémenté) : un onglet laissé ouvert,
    // une mise en veille ou un changement d'heure ne décalent pas le compte à rebours
    private refresh(): void {
        let left = Math.floor((new Date(this.end).getTime() - new Date().getTime()) / 1000);
        if (left < 0 || isNaN(left)) {
            left = 0;
        }
        this.days = Math.floor(left / 86400);
        this.hours = Math.floor((left % 86400) / 3600);
        this.minutes = Math.floor((left % 3600) / 60);
        this.seconds = left % 60;
    }
}
